import React from "react";

import { ExpressionView } from "../../../../Expressions/ExpressionView";
import { RuleTableRuleColumn } from "../../../DesignUI/CommonStyles";
import { RuleTableEditContext } from "../../../../rule-engine-core/Rule/Table/Rule/RuleTableEditContext";
import { RuleTableCell } from "../../../../rule-engine-core/Rule/Table/Rule/Structure/RuleTableCell";
import { RuleTableConfiguration } from "../../../../rule-engine-core/Rule/Table/Rule/RuleTableConfiguration";
import { Error } from "../../CommonUI/Error";
import { RuleTableColumn } from "../../../../rule-engine-core/Rule/Table/Rule/Structure/RuleTableRuleColumn";
import { StateManager } from "../../../../rule-engine-core/Common/StateManager";
import { ObserveMultiState } from "../../../../CommonUI/StateManagement/ObserveMultiState";
import { TestContext } from "../../../../CommonUI/Testing/TestContext";
import { BaseTestResultData } from "../../../../rule-engine-core/Common/Testing/BaseTestResultData";
import { RuleTableCellTestResult } from "../../../../rule-engine-core/Rule/Table/Rule/RuleTableTestResult";
import { ValidationIssue } from "../../../../rule-engine-core/Common/IDesignValidationProvider";
import { TestingConstants } from "../../../../CommonUI/Testing/TestingConstants";
import { ExpressionTestResultColorContext } from "../../../../Expressions/Testing/ExpressionTestResultColorContext";
import {
    ExpressionReactContext,
    ExpressionRenderType,
    expressionSettings,
} from "../../../../Expressions/Structure/ExpressionReactContext";
import { UIStyleConstants } from "../../../../rule-engine-core/Common/UIStyleConstants";

interface IRuleTableRuleCell {
    rule: RuleTableColumn;
    ruleDefinition: RuleTableConfiguration;
    editContext: RuleTableEditContext;
    cell: RuleTableCell;
    rowIndex: number;
    cellIndex: number;
}

// need to fix for selected
export function RuleTableRuleCell(props: IRuleTableRuleCell) {
    const { cell, ruleDefinition, rule, rowIndex, cellIndex } = props;
    const testContext = React.useContext(TestContext);

    const row = ruleDefinition.rows[rowIndex];
    const rowTestResult = testContext?.findItem(row._id) as BaseTestResultData;
    const cellTestResult = rowTestResult?.findItem(`${row._id}-${cell._columnId}`) as
        | RuleTableCellTestResult
        | undefined;

    if (testContext) {
        let issues: ValidationIssue[] = [];

        if (cellTestResult?.isError) {
            issues = [new ValidationIssue(cellTestResult?.result || "")];
        }

        let testcolor: string | undefined;
        let borderColor: string | undefined;
        let backgroundColor: string | undefined;

        if (cellTestResult?.result === "true") {
            testcolor = TestingConstants.TEXT_SUCCESS;
            borderColor = TestingConstants.BORDER_SUCCESS;
        } else if (cellTestResult?.result === "false") {
            testcolor = TestingConstants.TEXT_FAIL;
            borderColor = TestingConstants.BORDER_FAIL;
        }

        if (cellTestResult?.isError) {
            backgroundColor = TestingConstants.BACKGROUND_FAIL;
            borderColor = TestingConstants.BORDER_FAIL;
        }

        return (
            <TestContext.Provider value={cellTestResult}>
                <ExpressionTestResultColorContext.Provider value={testcolor}>
                    <ExpressionReactContext.Provider value={expressionSettings[ExpressionRenderType.TEXT]}>
                        <RuleTableRuleColumn
                            selected={false}
                            x={cellIndex + 1}
                            y={rowIndex + 2}
                            backgroundColor={backgroundColor}
                            borderColor={borderColor}
                        >
                            <ExpressionView
                                expression={cell.expression!}
                                hideValidation
                                color={{
                                    expression: UIStyleConstants.BLUE_COLOR,
                                    value: UIStyleConstants.GRAY_DARK_COLOR,
                                    variable: UIStyleConstants.GRAY_DARK_COLOR,
                                    missing: UIStyleConstants.GRAY_COLOR,
                                }}
                            />
                            <Error issues={issues} />
                        </RuleTableRuleColumn>
                    </ExpressionReactContext.Provider>
                </ExpressionTestResultColorContext.Provider>
            </TestContext.Provider>
        );
    }

    return (
        <ObserveMultiState
            listenTo={[rule, cell]}
            control={() => {
                let issues = ruleDefinition.getRuleCellValidationIssues(cell);

                return (
                    <RuleTableRuleColumn
                        selected={false}
                        x={cellIndex + 1}
                        y={rowIndex + 2}
                    >
                        <ExpressionView
                            expression={cell.expression!}
                            hideValidation
                            color={{
                                expression: UIStyleConstants.BLUE_COLOR,
                                value: UIStyleConstants.GRAY_DARK_COLOR,
                                variable: UIStyleConstants.GRAY_DARK_COLOR,
                                missing: "" + UIStyleConstants.GRAY_LIGHTER_COLOR,
                            }}
                            onDone={() => {
                                StateManager.changed(cell);
                                StateManager.changed(ruleDefinition);
                            }}
                        />

                        <Error issues={issues} />
                    </RuleTableRuleColumn>
                );
            }}
        />
    );
}
